export default "__VITE_ASSET__OkuDH7FA__"